import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetCustomerByIdInput } from './GetCustomerByIdInput';
import { GetCustomerByIdOutput } from './GetCustomerByIdOutput';

export class GetCustomerByIdService extends HttpServiceBase {

  handle = (input: GetCustomerByIdInput): Promise<Result<GetCustomerByIdOutput> | null> => {
    const promise = this.http.get<Result<GetCustomerByIdOutput>>(`${this.baseUrlSislogApi}/v2/customer/${input.id}`);
    return promise;
  }
}